import { AxiosInstance, CancelTokenSource } from 'axios';
import { EnvironmentConfig } from '../../config';
import { GeoData } from 'models/Geo/GeoData';
import { Projection } from 'models/Geo/Projection';

export interface CityRequest {
    name: string;
    states?: string[];
    countries?: string[];
    regions?: string[];
}

export interface CityResponse {
    [name: string]: {
        state: string;
        country: string;
        lat: number;
        lng: number;
    };
}

const citiesToStates = {
    "New York": "NY",
    "New York City": "NY",
    "Buffalo": "NY",
    "Rochester": "NY",
    "Yonkers": "NY",
    "Syracuse": "NY",
    "Albany": "NY",
    "New Rochelle": "NY",
    "Mount Vernon": "NY",
    "Schenectady": "NY",
    "Utica": "NY",
    "White Plains": "NY",
    "Hempstead": "NY",
    "Troy": "NY",
    "Niagara Falls": "NY",
    "Binghamton": "NY",
    "Freeport": "NY",
    "Valley Stream": "NY",
    "Los Angeles": "CA",
    "San Diego": "CA",
    "San Jose": "CA",
    "San Francisco": "CA",
    "Fresno": "CA",
    "Sacramento": "CA",
    "Long Beach": "CA",
    "Oakland": "CA",
    "Bakersfield": "CA",
    "Anaheim": "CA",
    "Santa Ana": "CA",
    "Riverside": "CA",
    "Stockton": "CA",
    "Chula Vista": "CA",
    "Irvine": "CA",
    "Fremont": "CA",
    "San Bernardino": "CA",
    "Modesto": "CA",
    "Fontana": "CA",
    "Oxnard": "CA",
    "Moreno Valley": "CA",
    "Huntington Beach": "CA",
    "Glendale": "CA",
    "Santa Clarita": "CA",
    "Garden Grove": "CA",
    "Oceanside": "CA",
    "Rancho Cucamonga": "CA",
    "Santa Rosa": "CA",
    "Ontario": "CA",
    "Lancaster": "CA",
    "Elk Grove": "CA",
    "Corona": "CA",
    "Palmdale": "CA",
    "Salinas": "CA",
    "Pomona": "CA",
    "Hayward": "CA",
    "Escondido": "CA",
    "Torrance": "CA",
    "Sunnyvale": "CA",
    "Orange": "CA",
    "Fullerton": "CA",
    "Pasadena": "CA",
    "Thousand Oaks": "CA",
    "Visalia": "CA",
    "Simi Valley": "CA",
    "Concord": "CA",
    "Roseville": "CA",
    "Victorville": "CA",
    "Santa Clara": "CA",
    "Vallejo": "CA",
    "Berkeley": "CA",
    "El Monte": "CA",
    "Downey": "CA",
    "Costa Mesa": "CA",
    "Inglewood": "CA",
    "Carlsbad": "CA",
    "San Buenaventura (Ventura)": "CA",
    "Fairfield": "CA",
    "West Covina": "CA",
    "Murrieta": "CA",
    "Richmond": "CA",
    "Norwalk": "CA",
    "Antioch": "CA",
    "Temecula": "CA",
    "Burbank": "CA",
    "Daly City": "CA",
    "Rialto": "CA",
    "Santa Maria": "CA",
    "El Cajon": "CA",
    "San Mateo": "CA",
    "Clovis": "CA",
    "Compton": "CA",
    "Jurupa Valley": "CA",
    "Vista": "CA",
    "South Gate": "CA",
    "Mission Viejo": "CA",
    "Vacaville": "CA",
    "Carson": "CA",
    "Hesperia": "CA",
    "Santa Monica": "CA",
    "Westminster": "CA",
    "Redding": "CA",
    "Santa Barbara": "CA",
    "Chico": "CA",
    "Newport Beach": "CA",
    "San Leandro": "CA",
    "San Marcos": "CA",
    "Whittier": "CA",
    "Hawthorne": "CA",
    "Citrus Heights": "CA",
    "Tracy": "CA",
    "Alhambra": "CA",
    "Livermore": "CA",
    "Buena Park": "CA",
    "Menifee": "CA",
    "Hemet": "CA",
    "Lakewood": "CA",
    "Merced": "CA",
    "Chino": "CA",
    "Indio": "CA",
    "Redwood City": "CA",
    "Lake Forest": "CA",
    "Napa": "CA",
    "Tustin": "CA",
    "Bellflower": "CA",
    "Mountain View": "CA",
    "Chino Hills": "CA",
    "Baldwin Park": "CA",
    "Alameda": "CA",
    "Upland": "CA",
    "San Ramon": "CA",
    "Folsom": "CA",
    "Pleasanton": "CA",
    "Union City": "CA",
    "Perris": "CA",
    "Manteca": "CA",
    "Lynwood": "CA",
    "Apple Valley": "CA",
    "Redlands": "CA",
    "Turlock": "CA",
    "Milpitas": "CA",
    "Redondo Beach": "CA",
    "Rancho Cordova": "CA",
    "Yorba Linda": "CA",
    "Palo Alto": "CA",
    "Davis": "CA",
    "Camarillo": "CA",
    "Walnut Creek": "CA",
    "Pittsburg": "CA",
    "South San Francisco": "CA",
    "Yuba City": "CA",
    "San Clemente": "CA",
    "Laguna Niguel": "CA",
    "Pico Rivera": "CA",
    "Montebello": "CA",
    "Lodi": "CA",
    "Madera": "CA",
    "Santa Cruz": "CA",
    "La Habra": "CA",
    "Encinitas": "CA",
    "Monterey Park": "CA",
    "Tulare": "CA",
    "Cupertino": "CA",
    "Gardena": "CA",
    "National City": "CA",
    "Rocklin": "CA",
    "Petaluma": "CA",
    "Huntington Park": "CA",
    "San Rafael": "CA",
    "La Mesa": "CA",
    "Arcadia": "CA",
    "Fountain Valley": "CA",
    "Diamond Bar": "CA",
    "Woodland": "CA",
    "Santee": "CA",
    "Lake Elsinore": "CA",
    "Porterville": "CA",
    "Paramount": "CA",
    "Eastvale": "CA",
    "Rosemead": "CA",
    "Hanford": "CA",
    "Highland": "CA",
    "Brentwood": "CA",
    "Novato": "CA",
    "Colton": "CA",
    "Cathedral City": "CA",
    "Delano": "CA",
    "Yucaipa": "CA",
    "Watsonville": "CA",
    "Placentia": "CA",
    "Glendora": "CA",
    "Gilroy": "CA",
    "Palm Desert": "CA",
    "Cerritos": "CA",
    "West Sacramento": "CA",
    "Aliso Viejo": "CA",
    "Poway": "CA",
    "La Mirada": "CA",
    "Rancho Santa Margarita": "CA",
    "Cypress": "CA",
    "Dublin": "CA",
    "Covina": "CA",
    "Azusa": "CA",
    "Palm Springs": "CA",
    "San Luis Obispo": "CA",
    "Ceres": "CA",
    "San Jacinto": "CA",
    "Lincoln": "CA",
    "Newark": "CA",
    "Lompoc": "CA",
    "El Centro": "CA",
    "Danville": "CA",
    "Bell Gardens": "CA",
    "Coachella": "CA",
    "Rancho Palos Verdes": "CA",
    "San Bruno": "CA",
    "Rohnert Park": "CA",
    "Brea": "CA",
    "La Puente": "CA",
    "Campbell": "CA",
    "San Gabriel": "CA",
    "Beaumont": "CA",
    "Morgan Hill": "CA",
    "Culver City": "CA",
    "Calexico": "CA",
    "Stanton": "CA",
    "La Quinta": "CA",
    "Pacifica": "CA",
    "Montclair": "CA",
    "Oakley": "CA",
    "Monrovia": "CA",
    "Los Banos": "CA",
    "Martinez": "CA",
    "Chicago": "IL",
    "Aurora": "IL",
    "Rockford": "IL",
    "Joliet": "IL",
    "Naperville": "IL",
    "Springfield": "IL",
    "Peoria": "IL",
    "Elgin": "IL",
    "Waukegan": "IL",
    "Cicero": "IL",
    "Champaign": "IL",
    "Bloomington": "IL",
    "Arlington Heights": "IL",
    "Evanston": "IL",
    "Decatur": "IL",
    "Schaumburg": "IL",
    "Bolingbrook": "IL",
    "Palatine": "IL",
    "Skokie": "IL",
    "Des Plaines": "IL",
    "Orland Park": "IL",
    "Tinley Park": "IL",
    "Oak Lawn": "IL",
    "Berwyn": "IL",
    "Mount Prospect": "IL",
    "Normal": "IL",
    "Wheaton": "IL",
    "Hoffman Estates": "IL",
    "Oak Park": "IL",
    "Downers Grove": "IL",
    "Elmhurst": "IL",
    "Glenview": "IL",
    "DeKalb": "IL",
    "Lombard": "IL",
    "Belleville": "IL",
    "Moline": "IL",
    "Buffalo Grove": "IL",
    "Bartlett": "IL",
    "Urbana": "IL",
    "Quincy": "IL",
    "Crystal Lake": "IL",
    "Plainfield": "IL",
    "Streamwood": "IL",
    "Carol Stream": "IL",
    "Romeoville": "IL",
    "Rock Island": "IL",
    "Hanover Park": "IL",
    "Carpentersville": "IL",
    "Wheeling": "IL",
    "Park Ridge": "IL",
    "Addison": "IL",
    "Calumet City": "IL",
    "Houston": "TX",
    "San Antonio": "TX",
    "Dallas": "TX",
    "Austin": "TX",
    "Fort Worth": "TX",
    "El Paso": "TX",
    "Arlington": "TX",
    "Corpus Christi": "TX",
    "Plano": "TX",
    "Laredo": "TX",
    "Lubbock": "TX",
    "Garland": "TX",
    "Irving": "TX",
    "Amarillo": "TX",
    "Grand Prairie": "TX",
    "Brownsville": "TX",
    "McKinney": "TX",
    "Mesquite": "TX",
    "McAllen": "TX",
    "Killeen": "TX",
    "Frisco": "TX",
    "Waco": "TX",
    "Carrollton": "TX",
    "Denton": "TX",
    "Midland": "TX",
    "Abilene": "TX",
    "Round Rock": "TX",
    "Odessa": "TX",
    "Wichita Falls": "TX",
    "Richardson": "TX",
    "Lewisville": "TX",
    "Tyler": "TX",
    "College Station": "TX",
    "Pearland": "TX",
    "San Angelo": "TX",
    "Allen": "TX",
    "League City": "TX",
    "Sugar Land": "TX",
    "Longview": "TX",
    "Edinburg": "TX",
    "Mission": "TX",
    "Bryan": "TX",
    "Baytown": "TX",
    "Pharr": "TX",
    "Temple": "TX",
    "Missouri City": "TX",
    "Flower Mound": "TX",
    "Harlingen": "TX",
    "North Richland Hills": "TX",
    "Victoria": "TX",
    "Conroe": "TX",
    "New Braunfels": "TX",
    "Mansfield": "TX",
    "Cedar Park": "TX",
    "Rowlett": "TX",
    "Port Arthur": "TX",
    "Euless": "TX",
    "Georgetown": "TX",
    "Pflugerville": "TX",
    "DeSoto": "TX",
    "Grapevine": "TX",
    "Bedford": "TX",
    "Galveston": "TX",
    "Cedar Hill": "TX",
    "Texas City": "TX",
    "Wylie": "TX",
    "Haltom City": "TX",
    "Keller": "TX",
    "Coppell": "TX",
    "Rockwall": "TX",
    "Huntsville": "TX",
    "Duncanville": "TX",
    "Sherman": "TX",
    "The Colony": "TX",
    "Burleson": "TX",
    "Hurst": "TX",
    "Texarkana": "TX",
    "Friendswood": "TX",
    "Weslaco": "TX",
    "Philadelphia": "PA",
    "Pittsburgh": "PA",
    "Allentown": "PA",
    "Erie": "PA",
    "Reading": "PA",
    "Scranton": "PA",
    "Bethlehem": "PA",
    "Harrisburg": "PA",
    "Altoona": "PA",
    "York": "PA",
    "State College": "PA",
    "Wilkes-Barre": "PA",
    "Phoenix": "AZ",
    "Tucson": "AZ",
    "Mesa": "AZ",
    "Chandler": "AZ",
    "Scottsdale": "AZ",
    "Gilbert": "AZ",
    "Tempe": "AZ",
    "Surprise": "AZ",
    "Yuma": "AZ",
    "Avondale": "AZ",
    "Goodyear": "AZ",
    "Flagstaff": "AZ",
    "Buckeye": "AZ",
    "Lake Havasu City": "AZ",
    "Casa Grande": "AZ",
    "Sierra Vista": "AZ",
    "Maricopa": "AZ",
    "Oro Valley": "AZ",
    "Prescott": "AZ",
    "Bullhead City": "AZ",
    "Prescott Valley": "AZ",
    "Marana": "AZ",
    "Apache Junction": "AZ",
    "Jacksonville": "FL",
    "Miami": "FL",
    "Tampa": "FL",
    "Orlando": "FL",
    "St. Petersburg": "FL",
    "Hialeah": "FL",
    "Tallahassee": "FL",
    "Fort Lauderdale": "FL",
    "Port St. Lucie": "FL",
    "Cape Coral": "FL",
    "Pembroke Pines": "FL",
    "Hollywood": "FL",
    "Miramar": "FL",
    "Gainesville": "FL",
    "Coral Springs": "FL",
    "Miami Gardens": "FL",
    "Clearwater": "FL",
    "Palm Bay": "FL",
    "Pompano Beach": "FL",
    "West Palm Beach": "FL",
    "Lakeland": "FL",
    "Davie": "FL",
    "Miami Beach": "FL",
    "Sunrise": "FL",
    "Plantation": "FL",
    "Boca Raton": "FL",
    "Deltona": "FL",
    "Largo": "FL",
    "Deerfield Beach": "FL",
    "Palm Coast": "FL",
    "Melbourne": "FL",
    "Boynton Beach": "FL",
    "Lauderhill": "FL",
    "Weston": "FL",
    "Fort Myers": "FL",
    "Kissimmee": "FL",
    "Homestead": "FL",
    "Tamarac": "FL",
    "Delray Beach": "FL",
    "Daytona Beach": "FL",
    "North Miami": "FL",
    "Wellington": "FL",
    "North Port": "FL",
    "Jupiter": "FL",
    "Ocala": "FL",
    "Port Orange": "FL",
    "Margate": "FL",
    "Coconut Creek": "FL",
    "Sanford": "FL",
    "Sarasota": "FL",
    "Pensacola": "FL",
    "Bradenton": "FL",
    "Palm Beach Gardens": "FL",
    "Pinellas Park": "FL",
    "Coral Gables": "FL",
    "Doral": "FL",
    "Bonita Springs": "FL",
    "Apopka": "FL",
    "Titusville": "FL",
    "North Miami Beach": "FL",
    "Oakland Park": "FL",
    "Fort Pierce": "FL",
    "North Lauderdale": "FL",
    "Cutler Bay": "FL",
    "Altamonte Springs": "FL",
    "St. Cloud": "FL",
    "Greenacres": "FL",
    "Ormond Beach": "FL",
    "Ocoee": "FL",
    "Hallandale Beach": "FL",
    "Winter Garden": "FL",
    "Aventura": "FL",
    "Indianapolis": "IN",
    "Fort Wayne": "IN",
    "Evansville": "IN",
    "South Bend": "IN",
    "Carmel": "IN",
    "Fishers": "IN",
    "Hammond": "IN",
    "Gary": "IN",
    "Muncie": "IN",
    "Lafayette": "IN",
    "Terre Haute": "IN",
    "Kokomo": "IN",
    "Anderson": "IN",
    "Noblesville": "IN",
    "Greenwood": "IN",
    "Elkhart": "IN",
    "Mishawaka": "IN",
    "Lawrence": "IN",
    "Jeffersonville": "IN",
    "Columbus": "IN",
    "Portage": "IN",
    "Cleveland": "OH",
    "Cincinnati": "OH",
    "Toledo": "OH",
    "Akron": "OH",
    "Dayton": "OH",
    "Parma": "OH",
    "Canton": "OH",
    "Youngstown": "OH",
    "Lorain": "OH",
    "Hamilton": "OH",
    "Kettering": "OH",
    "Elyria": "OH",
    "Cuyahoga Falls": "OH",
    "Middletown": "OH",
    "Euclid": "OH",
    "Mentor": "OH",
    "Beavercreek": "OH",
    "Cleveland Heights": "OH",
    "Strongsville": "OH",
    "Findlay": "OH",
    "Warren": "OH",
    "Lima": "OH",
    "Huber Heights": "OH",
    "Westerville": "OH",
    "Marion": "OH",
    "Grove City": "OH",
    "Charlotte": "NC",
    "Raleigh": "NC",
    "Greensboro": "NC",
    "Durham": "NC",
    "Winston-Salem": "NC",
    "Fayetteville": "NC",
    "Cary": "NC",
    "Wilmington": "NC",
    "High Point": "NC",
    "Greenville": "NC",
    "Asheville": "NC",
    "Gastonia": "NC",
    "Chapel Hill": "NC",
    "Rocky Mount": "NC",
    "Burlington": "NC",
    "Wilson": "NC",
    "Huntersville": "NC",
    "Kannapolis": "NC",
    "Apex": "NC",
    "Hickory": "NC",
    "Goldsboro": "NC",
    "Detroit": "MI",
    "Grand Rapids": "MI",
    "Sterling Heights": "MI",
    "Ann Arbor": "MI",
    "Lansing": "MI",
    "Flint": "MI",
    "Dearborn": "MI",
    "Livonia": "MI",
    "Westland": "MI",
    "Farmington Hills": "MI",
    "Kalamazoo": "MI",
    "Wyoming": "MI",
    "Southfield": "MI",
    "Rochester Hills": "MI",
    "Taylor": "MI",
    "Pontiac": "MI",
    "St. Clair Shores": "MI",
    "Royal Oak": "MI",
    "Novi": "MI",
    "Dearborn Heights": "MI",
    "Battle Creek": "MI",
    "Saginaw": "MI",
    "Kentwood": "MI",
    "East Lansing": "MI",
    "Lincoln Park": "MI",
    "Muskegon": "MI",
    "Memphis": "TN",
    "Nashville-Davidson": "TN",
    "Knoxville": "TN",
    "Chattanooga": "TN",
    "Clarksville": "TN",
    "Murfreesboro": "TN",
    "Jackson": "TN",
    "Franklin": "TN",
    "Johnson City": "TN",
    "Hendersonville": "TN",
    "Kingsport": "TN",
    "Collierville": "TN",
    "Smyrna": "TN",
    "Germantown": "TN",
    "Boston": "MA",
    "Worcester": "MA",
    "Lowell": "MA",
    "Cambridge": "MA",
    "New Bedford": "MA",
    "Brockton": "MA",
    "Lynn": "MA",
    "Fall River": "MA",
    "Newton": "MA",
    "Somerville": "MA",
    "Waltham": "MA",
    "Haverhill": "MA",
    "Malden": "MA",
    "Medford": "MA",
    "Taunton": "MA",
    "Chicopee": "MA",
    "Weymouth Town": "MA",
    "Revere": "MA",
    "Peabody": "MA",
    "Methuen": "MA",
    "Barnstable Town": "MA",
    "Pittsfield": "MA",
    "Attleboro": "MA",
    "Everett": "MA",
    "Salem": "MA",
    "Westfield": "MA",
    "Leominster": "MA",
    "Fitchburg": "MA",
    "Beverly": "MA",
    "Holyoke": "MA",
    "Marlborough": "MA",
    "Woburn": "MA",
    "Chelsea": "MA",
    "Seattle": "WA",
    "Spokane": "WA",
    "Tacoma": "WA",
    "Vancouver": "WA",
    "Bellevue": "WA",
    "Kent": "WA",
    "Renton": "WA",
    "Yakima": "WA",
    "Federal Way": "WA",
    "Spokane Valley": "WA",
    "Bellingham": "WA",
    "Kennewick": "WA",
    "Auburn": "WA",
    "Pasco": "WA",
    "Marysville": "WA",
    "Redmond": "WA",
    "Shoreline": "WA",
    "Richland": "WA",
    "Kirkland": "WA",
    "Burien": "WA",
    "Sammamish": "WA",
    "Olympia": "WA",
    "Lacey": "WA",
    "Edmonds": "WA",
    "Bremerton": "WA",
    "Puyallup": "WA",
    "Denver": "CO",
    "Colorado Springs": "CO",
    "Fort Collins": "CO",
    "Thornton": "CO",
    "Arvada": "CO",
    "Pueblo": "CO",
    "Centennial": "CO",
    "Boulder": "CO",
    "Greeley": "CO",
    "Longmont": "CO",
    "Loveland": "CO",
    "Grand Junction": "CO",
    "Broomfield": "CO",
    "Castle Rock": "CO",
    "Commerce City": "CO",
    "Parker": "CO",
    "Littleton": "CO",
    "Northglenn": "CO",
    "Washington": "DC",
    "Washington, D.c.": "DC",
    "Washington, D.C.": "DC",
    "Baltimore": "MD",
    "Frederick": "MD",
    "Rockville": "MD",
    "Gaithersburg": "MD",
    "Bowie": "MD",
    "Hagerstown": "MD",
    "Annapolis": "MD",
    "Louisville/Jefferson County": "KY",
    "Lexington-Fayette": "KY",
    "Bowling Green": "KY",
    "Owensboro": "KY",
    "Covington": "KY",
    "Portland": "OR",
    "Eugene": "OR",
    "Gresham": "OR",
    "Hillsboro": "OR",
    "Beaverton": "OR",
    "Bend": "OR",
    "Corvallis": "OR",
    "Tigard": "OR",
    "Lake Oswego": "OR",
    "Keizer": "OR",
    "Oklahoma City": "OK",
    "Tulsa": "OK",
    "Norman": "OK",
    "Broken Arrow": "OK",
    "Lawton": "OK",
    "Edmond": "OK",
    "Moore": "OK",
    "Midwest City": "OK",
    "Enid": "OK",
    "Stillwater": "OK",
    "Muskogee": "OK",
    "Milwaukee": "WI",
    "Madison": "WI",
    "Green Bay": "WI",
    "Kenosha": "WI",
    "Racine": "WI",
    "Appleton": "WI",
    "Waukesha": "WI",
    "Eau Claire": "WI",
    "Oshkosh": "WI",
    "Janesville": "WI",
    "West Allis": "WI",
    "La Crosse": "WI",
    "Sheboygan": "WI",
    "Wauwatosa": "WI",
    "Fond du Lac": "WI",
    "New Berlin": "WI",
    "Wausau": "WI",
    "Brookfield": "WI",
    "Greenfield": "WI",
    "Beloit": "WI",
    "Las Vegas": "NV",
    "Henderson": "NV",
    "Reno": "NV",
    "North Las Vegas": "NV",
    "Sparks": "NV",
    "Carson City": "NV",
    "Albuquerque": "NM",
    "Las Cruces": "NM",
    "Rio Rancho": "NM",
    "Santa Fe": "NM",
    "Roswell": "NM",
    "Farmington": "NM",
    "Kansas City": "MO",
    "St. Louis": "MO",
    "Independence": "MO",
    "Columbia": "MO",
    "Lee's Summit": "MO",
    "O'Fallon": "MO",
    "St. Joseph": "MO",
    "St. Charles": "MO",
    "St. Peters": "MO",
    "Blue Springs": "MO",
    "Florissant": "MO",
    "Joplin": "MO",
    "Chesterfield": "MO",
    "Jefferson City": "MO",
    "Cape Girardeau": "MO",
    "Virginia Beach": "VA",
    "Norfolk": "VA",
    "Chesapeake": "VA",
    "Newport News": "VA",
    "Alexandria": "VA",
    "Hampton": "VA",
    "Roanoke": "VA",
    "Portsmouth": "VA",
    "Suffolk": "VA",
    "Lynchburg": "VA",
    "Harrisonburg": "VA",
    "Leesburg": "VA",
    "Charlottesville": "VA",
    "Blacksburg": "VA",
    "Manassas": "VA",
    "Atlanta": "GA",
    "Augusta-Richmond County": "GA",
    "Savannah": "GA",
    "Athens-Clarke County": "GA",
    "Sandy Springs": "GA",
    "Macon": "GA",
    "Johns Creek": "GA",
    "Warner Robins": "GA",
    "Alpharetta": "GA",
    "Marietta": "GA",
    "Valdosta": "GA",
    "Dunwoody": "GA",
    "Omaha": "NE",
    "Grand Island": "NE",
    "Minneapolis": "MN",
    "St. Paul": "MN",
    "Duluth": "MN",
    "Brooklyn Park": "MN",
    "Plymouth": "MN",
    "Eagan": "MN",
    "Woodbury": "MN",
    "Maple Grove": "MN",
    "Eden Prairie": "MN",
    "Coon Rapids": "MN",
    "Burnsville": "MN",
    "Blaine": "MN",
    "Lakeville": "MN",
    "Minnetonka": "MN",
    "Edina": "MN",
    "St. Louis Park": "MN",
    "Mankato": "MN",
    "Maplewood": "MN",
    "Moorhead": "MN",
    "Shakopee": "MN",
    "Wichita": "KS",
    "Overland Park": "KS",
    "Olathe": "KS",
    "Topeka": "KS",
    "Shawnee": "KS",
    "Manhattan": "KS",
    "Lenexa": "KS",
    "Salina": "KS",
    "Hutchinson": "KS",
    "New Orleans": "LA",
    "Baton Rouge": "LA",
    "Shreveport": "LA",
    "Lake Charles": "LA",
    "Kenner": "LA",
    "Bossier City": "LA",
    "Monroe": "LA",
    "Honolulu": "HI",
    "Anchorage": "AK",
    "Jersey City": "NJ",
    "Paterson": "NJ",
    "Elizabeth": "NJ",
    "Clifton": "NJ",
    "Trenton": "NJ",
    "Camden": "NJ",
    "Passaic": "NJ",
    "Bayonne": "NJ",
    "East Orange": "NJ",
    "Vineland": "NJ",
    "New Brunswick": "NJ",
    "Hoboken": "NJ",
    "Perth Amboy": "NJ",
    "West New York": "NJ",
    "Hackensack": "NJ",
    "Sayreville": "NJ",
    "Kearny": "NJ",
    "Linden": "NJ",
    "Atlantic City": "NJ",
    "Boise City": "ID",
    "Nampa": "ID",
    "Meridian": "ID",
    "Idaho Falls": "ID",
    "Pocatello": "ID",
    "Caldwell": "ID",
    "Coeur d'Alene": "ID",
    "Twin Falls": "ID",
    "Birmingham": "AL",
    "Montgomery": "AL",
    "Mobile": "AL",
    "Tuscaloosa": "AL",
    "Hoover": "AL",
    "Dothan": "AL",
    "Florence": "AL",
    "Gadsden": "AL",
    "Des Moines": "IA",
    "Cedar Rapids": "IA",
    "Davenport": "IA",
    "Sioux City": "IA",
    "Iowa City": "IA",
    "Waterloo": "IA",
    "Council Bluffs": "IA",
    "Ames": "IA",
    "West Des Moines": "IA",
    "Dubuque": "IA",
    "Ankeny": "IA",
    "Urbandale": "IA",
    "Cedar Falls": "IA",
    "Little Rock": "AR",
    "Fort Smith": "AR",
    "Springdale": "AR",
    "Jonesboro": "AR",
    "North Little Rock": "AR",
    "Conway": "AR",
    "Rogers": "AR",
    "Pine Bluff": "AR",
    "Bentonville": "AR",
    "Salt Lake City": "UT",
    "West Valley City": "UT",
    "Provo": "UT",
    "West Jordan": "UT",
    "Orem": "UT",
    "Sandy": "UT",
    "Ogden": "UT",
    "St. George": "UT",
    "Layton": "UT",
    "Taylorsville": "UT",
    "South Jordan": "UT",
    "Lehi": "UT",
    "Logan": "UT",
    "Murray": "UT",
    "Draper": "UT",
    "Bountiful": "UT",
    "Riverton": "UT",
    "Roy": "UT",
    "Providence": "RI",
    "Warwick": "RI",
    "Cranston": "RI",
    "Pawtucket": "RI",
    "East Providence": "RI",
    "Woonsocket": "RI",
    "Gulfport": "MS",
    "Southaven": "MS",
    "Hattiesburg": "MS",
    "Biloxi": "MS",
    "Sioux Falls": "SD",
    "Rapid City": "SD",
    "Bridgeport": "CT",
    "New Haven": "CT",
    "Stamford": "CT",
    "Hartford": "CT",
    "Waterbury": "CT",
    "Danbury": "CT",
    "New Britain": "CT",
    "Meriden": "CT",
    "Bristol": "CT",
    "West Haven": "CT",
    "Milford": "CT",
    "Norwich": "CT",
    "Shelton": "CT",
    "Charleston": "SC",
    "North Charleston": "SC",
    "Mount Pleasant": "SC",
    "Rock Hill": "SC",
    "Summerville": "SC",
    "Sumter": "SC",
    "Goose Creek": "SC",
    "Hilton Head Island": "SC",
    "Spartanburg": "SC",
    "Manchester": "NH",
    "Nashua": "NH",
    "Fargo": "ND",
    "Bismarck": "ND",
    "Grand Forks": "ND",
    "Minot": "ND",
    "Billings": "MT",
    "Missoula": "MT",
    "Great Falls": "MT",
    "Bozeman": "MT",
    "Dover": "DE",
    "Cheyenne": "WY",
    "Casper": "WY",
    "Huntington": "WV"
}

// const esriTokenUrl = 'https://www.arcgis.com/sharing/rest/oauth2/token';
// const esriUnitedStates =
//     'https://services.arcgis.com/P3ePLMYs2RVChkJx/arcgis/rest/services/USA_Boundaries_2018/FeatureServer/2/query?f=geojson';
// const countiesWA = {
//     53001: 'Adams',
//     53003: 'Asotin',
//     53005: 'Benton',
//     53007: 'Chelan',
//     53009: 'Clallam',
//     53011: 'Clark',
//     53013: 'Columbia',
//     53015: 'Cowlitz',
//     53017: 'Douglas',
//     53019: 'Ferry',
//     53021: 'Franklin',
//     53023: 'Garfield',
//     53025: 'Grant',
//     53027: 'Grays Harbor',
//     53029: 'Island',
//     53031: 'Jefferson',
//     53033: 'King',
//     53035: 'Kitsap',
//     53037: 'Kittitas',
//     53039: 'Klickitat',
//     53041: 'Lewis',
//     53043: 'Lincoln',
//     53045: 'Mason',
//     53047: 'Okanogan',
//     53049: 'Pacific',
//     53051: 'Pend Oreille',
//     53053: 'Pierce',
//     53055: 'San Juan',
//     53057: 'Skagit',
//     53059: 'Skamania',
//     53061: 'Snohomish',
//     53063: 'Spokane',
//     53065: 'Stevens',
//     53067: 'Thurston',
//     53069: 'Wahkiakum',
//     53071: 'Walla Walla',
//     53073: 'Whatcom',
//     53075: 'Whitman',
//     53077: 'Yakima',
// };

export default class GeoService {
    // private cache = new Cache<Promise<Geography>>();
    // private esriToken: { token: string; expires: number };

    constructor(private readonly axios: AxiosInstance, private readonly env: EnvironmentConfig) {
        //this.getToken();
    }

    // getGeography(country: string, state: string, county: string): Promise<Geography> {
    //     const key = country + ':' + state + ':' + county;
    //     let entry = this.cache.get(key);

    //     if (!entry) {
    //         entry = this.geography();
    //         this.cache.set(key, entry);
    //     }

    //     return entry;
    // }

    async cities(cities: CityRequest[], cancelSource?: CancelTokenSource): Promise<CityResponse[]> {
        if (!cities || !cities.length) {
            return Promise.resolve([]);
        }

        const requestConfig = {
            method: 'POST' as const,
            url: this.env.geoRoot + 'cities?q',
            withCredentials: false,
            data: cities,
            cancelToken: cancelSource ? cancelSource.token : null,
        };

        return this.axios.request(requestConfig).then((response): any => {
            const data = response && response.data;
            return data;
        });
    }

    async resolveCityCoords(
        data: GeoData,
        projection: Projection,
        regions: string[],
        regionState: string,
        filterStatesUS: string[],
        filterCountries: string[],
        cancelSource?: CancelTokenSource
    ): Promise<any[]> {
        const args: CityRequest[] = data.items
            .filter(city => typeof city.x === 'string')
            .map(city => {
                const request: CityRequest = { name: city.x };

                if (regionState && regionState != 'all') {
                    request.states = [regionState];
                } else if (filterStatesUS && filterStatesUS.length) {
                    request.states = filterStatesUS;
                } else if (regions.includes("unitedStates") && !!citiesToStates[city.x]) {
                    request.states = [citiesToStates[city.x]];
                }

                if (filterCountries && filterCountries.length) {
                    request.countries = filterCountries;
                }

                if (regions.length && !regions.includes('philippines')) {
                    request.regions = regions;
                }

                return request;
            });

        return this.cities(args);
    }

    // private async geography(cancelSource?: CancelTokenSource): Promise<Geography> {
    //     let url = esriUnitedStates;

    //     const countyFips = Object.keys(countiesWA).join(',');
    //     const filter = `FIPS IN ( ${countyFips} )`;
    //     url += `&where=${encodeURIComponent(filter)}`;
    //     url += `&token=${this.esriToken.token}`;

    //     const requestConfig = {
    //         method: 'GET',
    //         url: url,
    //         withCredentials: false,
    //         cancelToken: cancelSource ? cancelSource.token : null,
    //     };

    //     return this.axios.request(requestConfig).then((response): any => {
    //         const data = response && response.data;
    //         if (data?.features) {
    //             data.features.forEach(feature => {
    //                 feature.properties.county = countiesWA[feature.properties.FIPS];
    //             });
    //         }

    //         return new Geography('' as any, 'county', data);
    //     });
    // }

    // private async getToken(cancelSource?: CancelTokenSource) {
    //     const args = new FormData();

    //     args.set('client_id', '9YZbUISMBgAuXwDL');
    //     args.set('client_secret', '0d364bc0e8c042dcbb0d5dcf246f823c');
    //     args.set('grant_type', 'client_credentials');

    //     const requestConfig = {
    //         method: 'POST',
    //         url: esriTokenUrl,
    //         withCredentials: false,
    //         data: args,
    //         cancelToken: cancelSource ? cancelSource.token : null,
    //     };

    //     this.axios.request(requestConfig).then((response): any => {
    //         const data = response && response.data;
    //         if (data?.access_token) {
    //             const expiresMilli = data.expires_in * 1000;
    //             this.esriToken = { token: data.access_token, expires: Date.now() + expiresMilli };
    //         }
    //     });
    // }
}
